<template>
	<div class="about">
		<div class="head">
			<div class="head-con"></div>
		</div>
		<div class="about-mid">
			<div class="dev-mid-tit">
				<div>————</div>
				<div class="tit-text">企业概况</div>
				<div>————</div>
			</div>
			<div class="ab-box">
				<div class="img-wrap">
					<img src="../../assets/images/b.jpg">
				</div>
				<div class="dev-mid-p">费而隐科技有限公司始于2000年，是甘肃新中大软件有限公司的全资子公司，公司以软件产品研发为主，自成立以来完成了白银公司银企互联系统、庆阳市非税收入管理系统银行及银联互通对接项目、集中供热管理系统、政府内控综合管理系统及预算绩效评价子系统、部门预算管理系统、国库账户管理系统等相关财政一体化管理系统。</div>
			</div>
			<div class="dev-mid-tit">
				<div>————</div>
				<div class="tit-text">ISO认证</div>
				<div>————</div>
			</div>
			<div class="ab-box box1">
				<div class="img-ios-wrap">
					<img src="../../assets/images/c2.png">
				</div>
				<div class="img-ios-wrap">
					<img src="../../assets/images/c1.png">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				name:'',
				email:'',
				phone:'',
				content:''
			}
		}
	}
</script>
<style scoped>
	.touch .about .head .head-con {
		background-image: url(../../assets/images/about_touch.png);
	}
	.pc .about .head .head-con {
		background-image: url(../../assets/images/about.png);
	}
	.touch .ab-box img {
		max-width: 80%;
	}
	.touch .ab-box .dev-mid-p {
		margin-top: 0.5rem;
		width: 80%;
		margin: 0.4rem auto 0;
	}
	.touch .box1 {
		padding-bottom: 0.8rem;
	}
	.touch .ab-box {
		overflow: hidden;
	}
	.touch .img-ios-wrap {
		float: left;
		width: 50%;
	}
	.pc .ab-box{
		display: flex;
		justify-content: space-between;
	}
	.pc .img-wrap{
		width: 450px;
	}
	.pc .ab-box .dev-mid-p{
		color: #fff;
		font-size: 22px;
		width: 650px;
	}
	.about img{
		max-width: 100%;
		display: block;
		margin: auto;
	}
	.pc .img-ios-wrap{
		width: 40%;
	}
	.pc .box1{
		justify-content: space-around;
		padding-bottom: 80px;
	}
</style>